import lodash from "lodash"
import moment from "moment"

import { createAtomFamily } from "utils/recoil"

const prefix = "containers/AddressPickerAdvanced/AddressBook/AddressBookDialog"

export const isOpenStateFamily = createAtomFamily({
  prefix,
  key: "isOpen"
})
